import { render, staticRenderFns } from "./IconExport.vue?vue&type=template&id=f38f083c&"
import script from "./IconExport.vue?vue&type=script&lang=js&"
export * from "./IconExport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports